import { createSelector } from 'reselect';
import { MeterRateTaskType, ReadingEventType } from '../jobs/jobs.types';
import { applicationSelectors } from '../application';
import dayjs from 'dayjs';
import { resolveLastReadingResultPerDay } from '../../helper/EvaluationHelper';
import { MeterReadingPreviewImage } from '../../screens/JobsScreen/components/JobDetails/components/JobMeterRateTaskReadingImages';

const getUnifiedReadingsForTask = (task: MeterRateTaskType, readingImages?: Array<MeterReadingPreviewImage>) =>
    createSelector(
        [applicationSelectors.isEvaluationShowCurrentReadingsAllowed, applicationSelectors.isEvaluationUseHistoricReadingsAllowed],
        (showCurrentResultsAllowed, showHistoricReadingsAllowed) => {
            let readings: Array<ReadingEventType & { readingImages?: Array<MeterReadingPreviewImage> }> = [];

            if (showHistoricReadingsAllowed) {
                task.readingEvents?.forEach((reading) => {
                    if (reading.readingValue != null) {
                        readings.push(reading);
                    }
                });
            }

            if (showCurrentResultsAllowed) {
                const lastReadingResultsPerDay = resolveLastReadingResultPerDay(task);

                if (lastReadingResultsPerDay) {
                    Object.values(lastReadingResultsPerDay).forEach((reading) => readings.push(reading));
                }

                if (readingImages != null && readingImages.length > 0) {
                    const lastReading = readings[readings.length - 1];

                    readings = readings.filter((r) => r.created !== lastReading?.created);

                    readings.push({ ...lastReading, readingImages: readingImages });
                }
            }

            return readings.sort((a, b) => {
                if (!a.readingDate || !b.readingDate) return 0;

                if (dayjs(a.readingDate).isBefore(b.readingDate)) {
                    return 1;
                } else {
                    return -1;
                }
            });
        },
    );

const evaluationSelectors = {
    getUnifiedReadingsForTask,
};

export default evaluationSelectors;
